var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 13.0667V15.3167H1.375V13.0667H0.25V15.3167C0.25 15.615 0.368526 15.9012 0.579505 16.1121C0.790483 16.3231 1.07663 16.4417 1.375 16.4417H12.625C12.9234 16.4417 13.2095 16.3231 13.4205 16.1121C13.6315 15.9012 13.75 15.615 13.75 15.3167V13.0667H12.625Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 7.44165L11.8319 6.64853L7.5625 10.9123V0.69165H6.4375V10.9123L2.16812 6.64853L1.375 7.44165L7 13.0667L12.625 7.44165Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/downloadBtn.a78fb2570fcc1dc581540726e4d9bacc.svg";
export { ForwardRef as ReactComponent };